import get from 'just-safe-get'
import set from 'just-safe-set'
import { currencies } from '@shared/constants'

export function disableIdGeneratorsOnEmpty(config) {
  const idGenerators = {
    staff: {
      template: 'staff_id_template',
      generate: 'generate_staff_id'
    },
    products: {
      template: 'product_id_template',
      generate: 'generate_product_id'
    },
    customers: {
      template: 'customer_number_template',
      generate: 'generate_customer_number'
    }
  }

  for (const [key, { template, generate }] of Object.entries(idGenerators)) {
    const isTemplateTruthy = get(config, [key, template])
    if (!isTemplateTruthy) {
      set(config, [key, generate], false)
    }
  }
}

/**
 * This is a helper function that returns the available currency list
 * @param {Array} branchCurrencies list of branch currencies
 * @param {String} defaultCurrency fall back currency
 * @returns {Array}
 */

export function calculateAvailableCurrencies(
  branchCurrencies = [],
  defaultCurrency
) {
  const uniqueCurrencies = new Set([defaultCurrency, ...branchCurrencies])

  return currencies.filter((currency) => uniqueCurrencies.has(currency))
}

export function cleanChangeSuggestionData(data) {
  if (!data || !Array.isArray(data) || !data.length) return null

  const isValidObject = (value) =>
    !!(
      value &&
      value.currency &&
      value.currency.length === 3 &&
      Number.isFinite(value.amount)
    )

  const result = data.filter((d) => isValidObject(d))

  return result.length ? result : null
}

// Basically the same as just-safe-set but we generate an object if a value is null.
// This is necessary when the initial database object defaults to null.
export function objectSafeSet(obj, props, value) {
  if (typeof props === 'string') {
    props = props.split('.')
  }
  if (typeof props === 'symbol') {
    props = [props]
  }
  var firstProp = props[0]
  if (firstProp === null && props.length > 1) {
    obj[firstProp] = {}
  }

  var lastProp = props.pop()
  if (!lastProp) {
    return false
  }
  if (firstProp === null && props.length) {
    obj[firstProp] = {}
  }
  var thisProp
  while ((thisProp = props.shift())) {
    if (typeof obj[thisProp] === 'undefined') {
      obj[thisProp] = {}
    }

    if (obj[thisProp] === null) {
      obj[thisProp] = {}
    }

    obj = obj[thisProp]
    if (!obj || typeof obj !== 'object') {
      return false
    }
  }
  obj[lastProp] = value
  return true
}
